import * as React from 'react';
var SardineContext = /*#__PURE__*/React.createContext({
  getDeviceResponse: function getDeviceResponse() {
    return undefined;
  },
  updateSardineConfig: function updateSardineConfig(config) {
    return false;
  },
  getSardineSessionKey: function getSardineSessionKey() {
    return '';
  },
  unbind: function unbind() {
    return false;
  },
  logoutUserOnSardine: function logoutUserOnSardine() {
    return false;
  },
  bind: function bind() {
    return false;
  }
});
SardineContext.displayName = 'SardineContext';
var Provider = SardineContext.Provider,
  Consumer = SardineContext.Consumer;
export { Provider, Consumer };
export default SardineContext;